import { Component, Input, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_accessibility from 'highcharts/modules/accessibility';
import { HttpClient } from '@angular/common/http';
import { PiechartService } from '../../piechart.service';
import { Observable, Subscription } from 'rxjs';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { InsightspopupService } from 'src/app/common/services/insightspopup.service';
import * as _ from 'lodash';

@Component({
  selector : 'app-piechart19-custom',
  templateUrl: './piechart19.component.html',
  styleUrls: ['./piechart19.component.css'],
  host: {
    '[class.popup-mode]': 'popUp',
    '[class.legend-left]': 'chartproperties?.legendPosition === "left"'
  },
  // styles: [`
  //   :host:not(.popup-mode) ::ng-deep .highcharts-t5nngmp-381 {
  //     height: auto !important;
  //     min-height: 300px !important;
  //   }
  //   :host:not(.popup-mode) ::ng-deep [class*="highcharts-"] {
  //     height: auto !important;
  //   }
  //   :host:not(.popup-mode) ::ng-deep .highcharts-container {
  //     height: 100% !important;
  //   }
  //   :host:not(.popup-mode) ::ng-deep .layout {
  //     height: 100%;
  //     width: 100%;
  //   }
  //   :host:not(.popup-mode) ::ng-deep [id^="chart-container"] {
  //     height: 100% !important;
  //     width: 100% !important;
  //   }
  //   :host(.legend-left):not(.popup-mode) ::ng-deep .highcharts-legend {
  //     left: calc(100% - 23em) !important;
  //   }
  //   :host(.legend-left.popup-mode) ::ng-deep .highcharts-legend {
  //     left: calc(100% - 23em) !important;
  //   }
 
  // `]
})
export class Piechart19ComponentCustom {
  constructor(
    private http: HttpClient,
    private piechartservice: PiechartService,
    private _configService: SnapshotService,
    private _customSnapshotService: CustomsnapshotService,
        public _insightsSerive: InsightspopupService
  ) {}

  jsondata: any;
  seriescolor: any;
  seriesgradientcolor:any;
  samplesizeconstant:any;
  chartproperties: any;
  chartimagepath:any;
    sharedLegendChart: any;
customDataModified:any;
  @Input() gridTempleteColumns: any;
  @Input() popUpp: any;
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any;
   globalColorMapping: Map<string, string> = new Map(); // Store consistent colors for categories

  // Height properties for template binding
  containerHeight: string = '11em';
  chartHeight: string = '100%';
  maxDataPoints: any = 2;
  significanceValue: any = "None";
  chartMainData: any = [];
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = "";
  // Multi-cohort properties
  cohorts: any[] = [];
  isMultiCohort: boolean = false;
  private subscriptions: Subscription = new Subscription();
  configuredProperties: any;
  
  ngOnInit(): void {
    
      // Subscribe to insights service changes to update heights dynamically
    this.subscriptions.add(
      this._insightsSerive.isInsightsSnapshot$.subscribe((insights) => {
        // Update the insightsopen property when insights show/hide
        if (insights) {
          
         
        }
      })
    );
    
    // Also subscribe to the regular insights observable
    this.subscriptions.add(
      this._insightsSerive.isInsights$.subscribe((insights) => {
        if (insights) {
          this._insightsSerive.insightsopen = insights.show;
         
        }
      })
    );
    if(this.isOutput){
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.customDataModified = this.customData.metric[0];
      this.customDataModified.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      this.maxDataPoints = this.popUp ? 6 : this.maxDataPoints;
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe((value: any) => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe((value: any) => {
          this.significanceValue = value;
          this.updateSig();
        }));
    }else{
      this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.seriescolor = this.piechartservice.color;
        // this.chartproperties.dataLabelSize = this.popUp ? '15px' : '12.6px';
        this.samplesizeconstant=this.piechartservice.samplesizeconstant;
        this.seriesgradientcolor=this.piechartservice.linearGradients1;
        this.chartimagepath=this.piechartservice.chartimagepath;
        this.plotChart('chart-container'+this.id, this.jsondata['data'], this.chartproperties);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateHeights();
    if (changes['customData'] && !changes['customData'].firstChange) {
      this.ngOnInit();
    }
  }
 get insightsOpen(): boolean {
    return this._insightsSerive.insightsopen;
  }

  // Method to update heights based on insights state
  private updateHeights(): void {
    if (this._insightsSerive.insightsopen) {
      this.containerHeight = '11rem';
      this.chartHeight = '11rem';
    } else {
      this.containerHeight = '11em';
      this.popUp ? this.chartHeight = '30rem' : this.chartHeight = '100%';
    }
       if(this.isOutput){
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.customDataModified = this.customData.metric[0];
      this.customDataModified.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      this.maxDataPoints = this.popUp ? 6 : this.maxDataPoints;
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe((value: any) => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe((value: any) => {
          this.significanceValue = value;
          this.updateSig();
        }));
         this.checkMultiCohort();
         if (!this.isMultiCohort) {
        // Single chart logic
        this.customData = this.customData.metric[0];
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      }
    }else{
      this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.seriescolor = this.piechartservice.color;
        // this.chartproperties.dataLabelSize = this.popUp ? '20px' : '12.6px';
        this.samplesizeconstant=this.piechartservice.samplesizeconstant;
        this.seriesgradientcolor=this.piechartservice.linearGradients1;
        this.chartimagepath=this.piechartservice.chartimagepath;
        this.plotChart('chart-container'+this.id, this.jsondata['data'], this.chartproperties);
      });
    }
   
  }
  updateSig() {
    this.subscriptions.add(
      this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
        this.customDataModified.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
        this.seriescolor = this.piechartservice.color;
        this.seriesgradientcolor = this.piechartservice.linearGradients1;
        this.samplesizeconstant = this.piechartservice.samplesizeconstant;
        this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
        this.chartproperties.dataLabelPosition = 'right';
        //  this.chartproperties.dataLabelSize = this.popUp ? '20px' : '12.6px';
        this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;
        this.Sig_LowerLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
         if (this.isMultiCohort) {
          // First, build global color mapping by processing all cohorts
          this.globalColorMapping.clear();
          let colorIndex = 0;
          const isgradient = this.chartproperties.gradientBarColor;
          
          this.cohorts.forEach((cohort) => {
            cohort.metric_value.forEach((mv: any) => {
              mv.data.forEach((dataArr: any) => {
                const seriesName = dataArr.colChild.split("|").length > 1 
                  ? dataArr.colChild.split("|")[1] 
                  : dataArr.colChild;
                
                if (!this.globalColorMapping.has(seriesName)) {
                  const color = !isgradient 
                    ? this.seriescolor[colorIndex] 
                    : this.seriesgradientcolor[colorIndex];
                  this.globalColorMapping.set(seriesName, color);
                  colorIndex++;
                }
              });
            });
          });
          
          console.log('Global color mapping:', this.globalColorMapping);
          
          // Then render multiple charts for each cohort
          this.cohorts.forEach((cohort, index) => {
            this.plotChart(
              'chart-container' + this.id + '-' + index,
              this.jsondata['data'],
              this.chartproperties,
              cohort
            );
          });
          
          // Create shared legend after all charts are rendered
          setTimeout(() => this.createSharedLegend(), 800);
        } else {
          this.plotChart(
            'chart-container' + this.id,
            this.jsondata['data'],
            this.chartproperties
          );
        }
      }));
  }
  createSharedLegend(): void {
    if (!this.isMultiCohort) {
      return;
    }
    
    const legendContainer = document.getElementById('shared-legend-container' + this.id);
    if (!legendContainer) {
      console.warn('Legend container not found');
      return;
    }
    
    // Collect all unique series from all cohorts with their colors
    const allSeriesData: any[] = [];
    const seriesMap = new Map<string, any>();
    
    // Get unique series across all cohorts
    this.chartMainData.forEach((item: any) => {
      const seriesName = item['Series Name'];
      if (!seriesMap.has(seriesName)) {
        // Prefer the explicit global color mapping (built in updateSig/preparechartdata)
        const mappedColor = this.globalColorMapping && this.globalColorMapping.has(seriesName)
          ? this.globalColorMapping.get(seriesName)
          : (item['color'] || item['colorLinearGradient'] || this.seriescolor[0]);

        seriesMap.set(seriesName, {
          name: seriesName,
          y: 0, // Dummy value for legend
          // store both properties so labelFormatter can read legendkeycolor consistently
          color: mappedColor,
          legendkeycolor: mappedColor
        });
      }
    });
    
    allSeriesData.push(...Array.from(seriesMap.values()));
    
    // Create a hidden chart just for the legend
    const chartproperties = this.chartproperties;
    const popUpState = this.popUp;
    let legendContainerWidth = legendContainer.offsetWidth || legendContainer.clientWidth || 0;
    // If the container is hidden or very small (e.g., measured 17px when offscreen), fall back to parent or window width
    if (!legendContainerWidth || legendContainerWidth < 100) {
      const parent = legendContainer.parentElement;
      if (parent && parent.clientWidth && parent.clientWidth > 100) {
        legendContainerWidth = parent.clientWidth;
      } else if (typeof window !== 'undefined' && window.innerWidth) {
        legendContainerWidth = Math.floor(window.innerWidth * 0.9);
      } else {
        legendContainerWidth = 1000;
      }
    }

    // For popup view, use same wide legend sizing as stack chart service (full visible legend)
    const popupLegendWidth = legendContainerWidth;
    // Use full width for legend items to avoid truncation
    const popupItemWidth = Math.max(150, Math.floor((legendContainerWidth - 20) / 2));

    // Compute rows so we can give the legend chart enough height and avoid Highcharts paging (1/2 arrows)
    const legendEffectiveWidth = popUpState ? popupLegendWidth : Math.floor(legendContainerWidth);
    const itemsPerRow = Math.max(1, Math.floor(legendEffectiveWidth / popupItemWidth));
    const legendRows = Math.max(1, Math.ceil(allSeriesData.length / itemsPerRow));
    const legendChartHeight = Math.max(100, Math.min(500, legendRows * 32));

    this.sharedLegendChart = Highcharts.chart(legendContainer, {
      chart: {
        type: 'pie',
        height: legendChartHeight,
        backgroundColor: 'transparent',
        margin: [0, 0, 0, 0],
        spacing: [0, 0, 0, 0]
      },
      title: { text: '' },
      credits: { enabled: false },
      tooltip: { enabled: false },
      plotOptions: {
        pie: {
          dataLabels: { enabled: false },
          showInLegend: true,
          states: {
            hover: { enabled: false },
            inactive: { enabled: false }
          }
        }
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        // Use larger widths in popup to display full legend (match stack chart behaviour)
        width: popUpState ? popupLegendWidth : undefined,
        itemWidth: popupItemWidth,
        maxHeight: legendChartHeight,
        navigation: {
          enabled: false
        },
        symbolWidth: 0,
        symbolHeight: 0,
        useHTML: true,
        itemMarginTop: 0,
        itemMarginBottom: 0,
        itemStyle: {
          fontWeight: "normal",
          fontSize: '0.8em',
          cursor: 'default',
          whiteSpace: 'normal',
          overflow: 'visible'
        },
        labelFormatter: function (): any {
          let point = this as any;
          let textcolor = chartproperties?.darkTheme ? 'white' : 'black';
          let label = point.name;
          // Prefer explicit legendkeycolor set on data items
          const dotColor = point.legendkeycolor || point.color || '#ccc';
          // Calculate text max width based on legend item width to show full text
          const itemWidthPx = popupItemWidth;
          const dotWidthPx = 10;
          const gapPx = 6;
          const textMaxPx = Math.max(0, itemWidthPx - dotWidthPx - gapPx - 4);
          return '<div style="display:flex;align-items:flex-start;font-size:0.8em;margin-bottom:4px;white-space:normal;width:' + itemWidthPx + 'px;box-sizing:border-box;overflow:hidden;" title="' + point.name + '">'
            + '<div style="flex:0 0 ' + dotWidthPx + 'px;width:' + dotWidthPx + 'px;height:' + dotWidthPx + 'px;background-color:' + dotColor + ';border-radius:50%;margin-top:2px;flex-shrink:0;"></div>'
            + '<div style="flex:1 1 auto;max-width:' + textMaxPx + 'px;font-size:0.8em;margin-left:' + gapPx + 'px;color:' + textcolor + ';line-height:1.3;word-wrap:break-word;overflow-wrap:break-word;">' + label + '</div>'
            + '</div>';
        }
      },
      series: [{
        type: 'pie',
        name: 'Legend',
        data: allSeriesData,
        size: 0, // Hide the actual pie chart
        innerSize: 0,
        visible: false
      }]
    } as any);
  }

  customization(): Observable<any[]> {
    //return this.piechartservice.PieChart1to10customizationList();
    return _.cloneDeep(this._customSnapshotService.getChartCustomization("09/Pie Chart", this._customSnapshotService.selectedSnapshotType?.name,this._configService.audienceCohortType));
  }
  checkMultiCohort(): void {
  
    if (this._configService.outputSnapshotData?.audienceCohortType == 'multiple') {
      
      const metricValues = this.customData.metric[0].metric_value;
      
      // Extract unique cohorts from colChild in the data array
      const cohortSet = new Set<string>();
      
      // Parse through all metric values to find unique cohorts
      metricValues.forEach((mv: any) => {
        if (mv.data && mv.data.length > 0) {
          mv.data.forEach((dataItem: any) => {
            if (dataItem.colChild) {
              // Extract cohort name from colChild (e.g., "Audience|Gender|Male" -> "Male")
              const parts = dataItem.colChild.split('|');
              if (parts.length > 0) {
                const cohortName = parts[parts.length - 1]; // Get the last part (e.g., "Male", "Female")
                cohortSet.add(cohortName);
              }
            }
          });
        }
      });
      
      const uniqueCohorts = Array.from(cohortSet);
      console.log('Detected cohorts:', uniqueCohorts);
      
      // If we have multiple cohorts, enable multi-cohort mode
      if (uniqueCohorts.length > 1) {
        this.isMultiCohort = true;
        
        // Create cohort data structure
        this.cohorts = uniqueCohorts.map(cohortName => {
          return {
            title: cohortName,
            metric_value: metricValues.map((mv: any) => {
              return {
                ...mv,
                data: mv.data.filter((d: any) => {
                  const parts = d.colChild ? d.colChild.split('|') : [];
                  const itemCohort = parts[parts.length - 1];
                  return itemCohort === cohortName;
                })
              };
            }).filter((mv: any) => mv.data.length > 0) // Only include metric_values that have data for this cohort
          };
        });
        
        console.log('Multi-cohort mode enabled with cohorts:', this.cohorts);
      } else {
        console.log('Single cohort mode - only one cohort found:', uniqueCohorts);
      }
    }
  }
  seriesdata: any;
  cov: any;
  significance: any;
  samplesize:any;
  label: any;
  datalength:number=0;
  sum:number=0;
  preparechartdata(data: any,islowsample:boolean,isgradient:boolean) {

    if (this.isOutput) {
      let seriesdata: any[] = [];
      let cov: any = [];
      let significance: any = [];
      let samplesize: any = [];
      let label: any = [];
      let i = 0;
      let innerSize = 40;
      let size = 35;
      let d: any = {};
      d.animation = this.piechartservice.allowAnimation;
      d.data = [];
      data.forEach((dat: any) => {

        cov.push(dat['Change value vs PY']);
        significance.push(dat['Significance']);
        label.push(dat['Label']);
        samplesize.push(dat['Sample size'])
        let value = isNaN(parseFloat(dat['Value'])) || parseFloat(dat['Value']) == null ? null : parseFloat(Number(dat['Value']).toFixed(this.chartproperties.decimalRoundOff));
        let finalvalue = !islowsample ? value : (parseFloat(dat['Sample size']) > this.samplesizeconstant ? value : 0)
        
        // For multi-cohort, ensure consistent colors across cohorts
        const seriesName = dat['Series Name'];
        let assignedColor: string;
        
        if (this.isMultiCohort) {
          // Check if this series already has a color assigned
          if (!this.globalColorMapping.has(seriesName)) {
            // Assign a new color from the palette
            const colorIndex = this.globalColorMapping.size;
            assignedColor = !isgradient ? this.seriescolor[colorIndex] : this.seriesgradientcolor[colorIndex];
            this.globalColorMapping.set(seriesName, assignedColor);
          } else {
            // Use the already assigned color
            assignedColor = this.globalColorMapping.get(seriesName)!;
          }
        } else {
          // Single cohort mode - use existing logic
          assignedColor = dat['color'] ? dat['color'] : (!isgradient ? this.seriescolor[i++] : this.seriesgradientcolor[i++]);
        }
        
        let m = {
          name: dat['Series Name'],
          y: (this._configService.userRole != "superadmin" && Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (finalvalue == null ? 0 : finalvalue)),
          indexValue: (this._configService.userRole != "superadmin" && Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (dat['ValueForIndex'] == null ? 0 : dat['ValueForIndex'])),
          actualIndexValue: dat['ActualIndexValue'],
          y1: this._configService.isIndexSelected ? finalvalue : (this._configService.userRole != "superadmin" && Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (finalvalue == null ? 0 : finalvalue)),
          
          legendkeycolor: assignedColor,
          actualcolor: assignedColor,
          color: assignedColor,

          cov: dat['Change value vs PY'],
          significance: dat['Significance'],
          significance2: dat['Significance2'],
          samplesize: dat['Sample size'],
          tooltip: "",
          isPercentage: dat["isPercentage"],
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          Significance_Value: dat["Significance_Value"]
        }
        
        // Increment i only for non-multi-cohort mode
        if (!this.isMultiCohort && !dat['color']) {
          i++;
        }
        
        d.data.push(m);
        this.datalength++;
      });
      seriesdata = [d];
      d = {};
      this.cov = cov;
      this.significance = significance;
      this.label = label;
      this.samplesize = samplesize;
      this.seriesdata = seriesdata;

    }
    else{
      let seriesdata: any[] = [];
      let d: any = {};
      let cov: any = [];
      let significance: any = [];
      let samplesize:any=[];
      let label: any = [];
      let i = 0;
      d.data = [];
      d.animation=this.piechartservice.allowAnimation;
      data.forEach((dat: any) => {
        cov.push(dat['Change value vs PY']);
        significance.push(dat['Significance']);
        label.push(dat['Label']);
        samplesize.push(dat['Sample size'])
        d.name = dat['Category Name'];
        let value=isNaN(parseFloat(dat['Rounded Value']))||parseFloat(dat['Rounded Value'])==null?null:Number(parseFloat(dat['Value']).toFixed(this.chartproperties.decimalRoundOff))
        let finalvalue=!islowsample?value:(parseFloat(dat['Sample size'])>this.samplesizeconstant?value:0)
        
        // For multi-cohort, ensure consistent colors across cohorts
        const seriesName = dat['Series Name'];
        let assignedColor: string;
        
        if (this.isMultiCohort) {
          // Check if this series already has a color assigned
          if (!this.globalColorMapping.has(seriesName)) {
            // Assign a new color from the palette
            const colorIndex = this.globalColorMapping.size;
            assignedColor = !isgradient ? this.seriescolor[colorIndex] : this.seriesgradientcolor[colorIndex];
            this.globalColorMapping.set(seriesName, assignedColor);
          } else {
            // Use the already assigned color
            assignedColor = this.globalColorMapping.get(seriesName)!;
          }
        } else {
          // Single cohort mode - use existing logic
          assignedColor = !isgradient ? this.seriescolor[i++] : this.seriesgradientcolor[i++];
        }
        
        let m = {
          name: dat['Series Name'],
          y: finalvalue==null?0:finalvalue,
          y1:finalvalue,
          actualcolor: assignedColor,
          color: assignedColor,
          cov:dat['Change value vs PY'],
          significance:dat['Significance'],
          significance2:dat['Significance2'],
          samplesize:dat['Sample size'],
          tooltip:""
        };
        this.sum+=(finalvalue==null?0:finalvalue)
        d.data.push(m);
        this.datalength++;
      });
      seriesdata = [d];
      d = {};
      this.cov = cov;
      this.significance = significance;
      this.label = label;
      this.samplesize=samplesize;
      this.seriesdata = seriesdata;
    }
    
  }

  preparemainChartData(data: any) {
    this.chartMainData = [];
    // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;
        
    if (this._configService.selectedSnapshotType.toLowerCase().includes('multi')) {

      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": dataArr.colChild.split("|").length>1?dataArr.colChild.split("|")[1]:dataArr.colChild,
            "Category Name": lev2.metric_group,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "color": dataArr.color,
            "colorLinearGradient": dataArr.colorLinearGradient,
          }
          this.chartMainData.push(d1);
        })
      })
    }
    else {
      let i = 0;
      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": lev2.option,
            "Category Name": lev2.metric_group||dataArr.colChild,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "color": dataArr.color,
            "colorLinearGradient": dataArr.colorLinearGradient,
          }
          this.chartMainData.push(d1);
        });
      });
    }

  }
  private getResponsiveChartProps(): {
    center: [string, string | number],
    size: string,
    innerSize: string,
    fontSize: string,
    labelDistance: number,
    connectorWidth: number
  } {
    const containerElement = document.getElementById('chart-container' + this.id);

    // Helper to adjust y position by 2%
    const adjustY = (y: string) => {
      if (!this.insightsOpen) return y;
      if (typeof y === 'string' && y.endsWith('%')) {
        const num = parseFloat(y);
        return (num + 20) + '%';
      }
      return y;
    };

    // If popup is true, use fixed properties
    if (this.popUp && !this.chartproperties?.showLegend) {
      return {
        center: ['50%', adjustY('50%')],
        size: '90%',
        innerSize: '40%',
        fontSize: '0.9rem',
        labelDistance: -20,
        connectorWidth: 2
      };
    }

    if (!containerElement) {
      return { 
        center: ['50%', adjustY('40%')], 
        size: '75%', 
        innerSize: '45%',
        fontSize: '0.8rem',
        labelDistance: -20,
        connectorWidth: 1
      };
    }

    const containerWidth = containerElement.offsetWidth;
    const containerHeight = containerElement.offsetHeight;
    const minDimension = Math.min(containerWidth, containerHeight);

     if (minDimension < 260) {
      return {
        center: [
          this.chartproperties?.legendPosition === 'left' ? '70%' : (this.chartproperties?.legendPosition === 'right' ? '30%' : this.chartproperties?.legendPosition === 'bottom' ? this.popUp?'50%' : '50%':'50%'),
          adjustY(this.chartproperties?.legendPosition === 'bottom' ? (this.popUp?'45%' : '47%') : '55%')
        ],
        size: this.chartproperties?.showLegend ? '80%' : '75%',
        innerSize: this.popUp?'90%':'35%',
        fontSize: '0.7rem',
        labelDistance: -20,
        connectorWidth: 1
      };
    }
    // 📱 Mobile/Small screens (< 400px)
    if (minDimension < 400) {
      return {
        center: [
          this.chartproperties?.legendPosition === 'left' ? '70%' : (this.chartproperties?.legendPosition === 'right' ? '30%' : this.chartproperties?.legendPosition === 'bottom' ? this.popUp?'50%' : '50%':'50%'),
          adjustY(this.chartproperties?.legendPosition === 'bottom' ? (this.popUp?'45%' : '47%') : this.popUp?'70%':'55%')
        ],
        size: this.chartproperties?.showLegend ? '80%' : '75%',
        innerSize: this.popUp?'30%':'35%',
        fontSize: '0.7rem',
        labelDistance: -20,
        connectorWidth: 1
      };
    }
    let chartSize = '75%';
    if (this.chartproperties?.legendPosition === 'left') {
      chartSize = '90%'; // Maximize chart size for left legend
    }
    if (minDimension < 500) {
      return {
        center: [
          this.chartproperties?.legendPosition === 'left' ? this.popUp?'70%':'65%' : (this.chartproperties?.legendPosition === 'right' ? this.popUp?'35%':'30%' : '50%'),
          adjustY(this.chartproperties?.legendPosition === 'bottom' ? (this.popUp?'62%':'33%'):this.popUp?'70%':'60%')
        ],
        size: chartSize,
        innerSize: '42%',
        fontSize: '0.8rem',
        labelDistance: -22,
        connectorWidth: 1
      };
    }
    // 📱 Tablet/Medium screens (400-800px)
    if (minDimension < 800) {
      return {
        center: [
          this.chartproperties?.legendPosition === 'left' ? this.popUp?'70%':'55%' : (this.chartproperties?.legendPosition === 'right' ? this.popUp?'35%':'50%' : '50%'),
          adjustY(this.chartproperties?.legendPosition === 'bottom' ? (this.popUp?'62%':'33%'):'60%')
        ],
        size: chartSize,
        innerSize: '42%',
        fontSize: '0.8rem',
        labelDistance: -22,
        connectorWidth: 1
      };
    }

    // 🖥️ Desktop/Large screens (800px+)

    return {
      center: [
        this.chartproperties?.legendPosition === 'left' ? '65%' : (this.chartproperties?.legendPosition === 'right' ? '35%' : '50%'),
        adjustY(this.chartproperties?.legendPosition === 'bottom' ? '50%' : '40%')
      ],
      size: chartSize,
      innerSize: '45%',
      fontSize: '0.9rem',
      labelDistance: -25,
      connectorWidth: 2
    };
  }
    private getLegendItemWidth(chartproperties: any, popUp: boolean): number {
  const containerElement = document.getElementById('chart-container' + this.id);
  let minDimension = 800; // default for desktop
  if (containerElement) {
    const containerWidth = containerElement.offsetWidth;
    const containerHeight = containerElement.offsetHeight;
    minDimension = Math.min(containerWidth, containerHeight);
  }

  // Responsive logic based on minDimension
  if (popUp) {
    if (minDimension < 400) {
      return 250;
    }
    if (minDimension < 500) {
      return 420;
    }
    return 520;
  } else {
    if (minDimension < 400) {
      if (chartproperties.legendPosition === 'bottom') return 120;
      if (chartproperties.legendPosition === 'left') return 200;
      return 250;
    }
   
    if (minDimension < 800) {
      if (chartproperties.legendPosition === 'bottom') return 200;
      if (chartproperties.legendPosition === 'left') return 220;
      return 400;
    }
    // Desktop/Large screens
    if (chartproperties.legendPosition === 'bottom') return 200;
    if (chartproperties.legendPosition === 'left') return 220;
    return 250;
  }
}
  private getLegendXPosition(chartproperties: any, popUp: boolean): number {
  const containerElement = document.getElementById('chart-container' + this.id);
  let minDimension = 800; // default for desktop
  if (containerElement) {
    const containerWidth = containerElement.offsetWidth;
    const containerHeight = containerElement.offsetHeight;
    minDimension = Math.min(containerWidth, containerHeight);
  }

  // Responsive logic based on minDimension
  if (popUp) {
    if (minDimension < 400) {
      if (chartproperties.legendPosition === 'right') return 10;
      if (chartproperties.legendPosition === 'left') return 5;
      return 0;
    }
    if (minDimension < 500) {
      if (chartproperties.legendPosition === 'right') return 5;
      if (chartproperties.legendPosition === 'left') return 40;
      return 0;
    }
    if (chartproperties.legendPosition === 'right') return 10;
    if (chartproperties.legendPosition === 'left') return 15;
    return 0;
  } else {

    if (minDimension < 220) {
     if (chartproperties.legendPosition === 'right') return 100;
      if (chartproperties.legendPosition === 'left') return 120;
      return 10;
    }
    if (minDimension < 260) {
     if (chartproperties.legendPosition === 'right') return 70;
      if (chartproperties.legendPosition === 'left') return -50;
      return 10;
    }
     if (minDimension < 300) {
     if (chartproperties.legendPosition === 'right') return 90;
      if (chartproperties.legendPosition === 'left') return 20;
      return 10;
    }
    if (minDimension < 400) {
     if (chartproperties.legendPosition === 'right') return 60;
      if (chartproperties.legendPosition === 'left') return 20;
      return 10;
    }
   if (minDimension < 600) {
      if (chartproperties.legendPosition === 'right') return 100;
      if (chartproperties.legendPosition === 'left') return 100;
      return 20;
    }
    if (minDimension < 800) {
      if (chartproperties.legendPosition === 'right') return 10;
      if (chartproperties.legendPosition === 'left') return 150;
      return 20;
    }
    // Desktop/Large screens
    if (chartproperties.legendPosition === 'right') return 120;
    if (chartproperties.legendPosition === 'left') return -10;
    return 20;
  }
}
  chart: any;
  plotChart(containerId: any, jsondata: any, chartproperties: any,cohortData?: any) {
    let popUpState=this.popUp;
    const componentId = this.id;
      let height = this.height;
    let insightsOpen=  this._insightsSerive.insightsopen;
    let outputdetails=this._configService.output_details;
       const getLegendItemWidth = this.getLegendItemWidth.bind(this);
    if (this.isOutput) {
      localStorage.setItem("properties", JSON.stringify(this.chartproperties));
     const showLegendForChart = this.isMultiCohort ? false : chartproperties.showLegend;

      let samplesizeconstant = this.samplesizeconstant;
      let chartimagepath = this.chartimagepath;
            const dataToUse = cohortData ? cohortData : this.customDataModified;
      this.preparemainChartData(dataToUse);
      this.preparechartdata(this.chartMainData, chartproperties.datalabelStyle == 'ls', chartproperties.gradientBarColor);
      const configService = this._configService;

      this.chart = Highcharts.chart(containerId, {
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        chart: {
          type: 'pie',
          spacingBottom: this.popUp?chartproperties.showLegend && chartproperties.legendPosition == "bottom" ? 10 : 0:0,

          marginBottom: this.popUp?chartproperties.showLegend && chartproperties.legendPosition == "bottom" ? 10 : 10:0, // Slightly more margin for cleaner separation
          marginRight: chartproperties.legendPosition == "right" ? 10 : this.popUp?10:(chartproperties.legendPosition == "left" ? 3 : 5),
          marginLeft:this.popUp?5:chartproperties.legendPosition=="left"?10:10,
          // marginTop:50,
          backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
          style: {
            fontFamily: this.piechartservice.fontFamily,
            width: '100%',

            // width:300,
            // height:"100%"
          },
          events: {
            load: function () {
              const chart = this as any;
              window.addEventListener('resize', function () {
                chart.reflow();
              });
              
             
              if (chartproperties.legendPosition === 'right'  && popUpState==false) {
                // Add class to chart container for CSS targeting
                const chartContainer = chart.container;
                if (chartContainer) {
                  chartContainer.classList.add('legend-right-positioned');
                }
                
                // Also try to add to legend elements directly
                const legendItems = chart.container.querySelectorAll('.highcharts-legend-item');
                legendItems.forEach((item: any) => {
                  if (item) {
                    item.classList.add('legend-right-positioned');
                  }
                });
                
                // Add to legend group as well
                const legendGroup = chart.legend.group;
                if (legendGroup && legendGroup.element) {
                  legendGroup.element.classList.add('legend-right-positioned');
                }
                
                // Fix navigation positioning for left legends
                setTimeout(() => {
                  const navElements = chart.container.querySelectorAll('.highcharts-legend-navigation');
                  navElements.forEach((nav: any) => {
                    if (nav) {
                      nav.style.visibility = 'visible';
                      nav.style.display = 'block';
                      nav.style.opacity = '1';
                    }
                  });
                }, 100);
              }
            },
            render: function() {
              
              const chart = this as any;
              if (chartproperties.legendPosition === 'left' && popUpState==false) {
                // Add class to chart container for CSS targeting
                const chartContainer = chart.container;
                if (chartContainer) {
                  chartContainer.classList.add('legend-left-positioned');
                }
                
                // Also try to add to legend elements directly
                const legendItems = chart.container.querySelectorAll('.highcharts-legend-item');
                legendItems.forEach((item: any) => {
                  if (item) {
                    item.classList.add('legend-left-positioned');
                  }
                });
                
                // Add to legend group as well
                const legendGroup = chart.legend.group;
                if (legendGroup && legendGroup.element) {
                  legendGroup.element.classList.add('legend-left-positioned');
                }
                
                // Fix navigation positioning for left legends
                setTimeout(() => {
                  const navElements = chart.container.querySelectorAll('.highcharts-legend-navigation');
                  navElements.forEach((nav: any) => {
                    if (nav) {
                      nav.style.visibility = 'visible';
                      nav.style.display = 'block';
                      nav.style.opacity = '1';
                    }
                  });
                }, 100);
              }
            }
          }
        },
        title: {
          text: "",
          align: chartproperties.chartTitlePosition,
          verticalAlign: 'top',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
            fontSize: "2rem"
          },
        },
    legend: {
        navigation: {
            itemMarginLeft: chartproperties.legendPosition == 'left' ? 0 : 10,
            activeColor: '#7f7f7f',
            animation: true,
            arrowSize: chartproperties.legendPosition == 'left' ? 12 : 10,
            inactiveColor: '#ccc',
            enabled: false, // Explicitly enable navigation arrows
            marginBottom: this.popUp && chartproperties.legendPosition == 'bottom' ? 15 : 10, // Extra space for navigation arrows
            marginRight: chartproperties.legendPosition == 'left' ? 5 : 0,
            x: chartproperties.legendPosition == 'left' ? 0 : undefined,
            style: {
              fontSize: '0.7em',
              color: chartproperties.darkTheme ? 'white' : '#333',
            },
 
          itemStyle: {
                color: chartproperties.darkTheme ? 'white' : 'black', // Change this to your desired color
                fontWeight: 'normal',
                fontSize: '0.8em'
            },
            verticalAlign:
        chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
          },
          layout:
        chartproperties.legendPosition != 'bottom'
          ? 'vertical'
          : 'horizontal',
           enabled: showLegendForChart,
             x: chartproperties.legendPosition=='left' ?10:this.getLegendXPosition(chartproperties, this.popUp),
          // y:chartproperties.legendPosition == 'bottom'?0:4,
          maxHeight: this.popUp ? (chartproperties.legendPosition == 'bottom' ? 120 : 300) : (chartproperties.legendPosition == 'bottom' ? 60 : 200), // Adequate height for popup bottom legend
        //  x: this.popUp ? (chartproperties.legendPosition == 'right' ? 5 : (chartproperties.legendPosition == 'left' ? 10 : 0)) : chartproperties.legendPosition == 'right' ? 100 : (chartproperties.legendPosition == 'left' ? -10 : 20),
              y: (() => {
                const moveDown = insightsOpen ? 20 : 0; // px, adjust as needed
                if (this.popUp) {
                  return chartproperties.legendPosition == 'bottom' ? 0 + moveDown : 0 + moveDown;
                } else {
                  if (chartproperties.legendPosition === 'left' || chartproperties.legendPosition === 'right') {
                    return -30 + moveDown;
                  } else if (chartproperties.legendPosition === 'bottom') {
                    return -50 + moveDown;
                  }
                  return 0 + moveDown;
                }
              })(),
            verticalAlign: chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
          // width: height=='100%'?100:'100%',
          itemWidth:this.getLegendItemWidth(chartproperties, this.popUp),
            //itemWidth: this.popUp?520:chartproperties.legendPosition=='bottom'?200:(chartproperties.legendPosition=='left'?220:250), // Set legend item width (adjust as needed)
          align:  chartproperties.legendPosition,
           symbolWidth: 0,  // Hide default symbols - using custom HTML symbols
          symbolHeight: 0, // Hide default symbols - using custom HTML symbols
          //symbolWidth: -1,
          //symbolHeight: -1,
          useHTML: true,
          itemMarginTop: 0,    // Adjust this value to reduce the top margin
         
          itemMarginBottom:this.popUp? 10:5,
          itemStyle: {
            fontWeight: "normal",
            // fontSize: '0.8em',
            fontSize:(0.8 * ((this.popUp || this.height === '100%') ? 1.45 : 1)) + 'em',
            cursor: 'pointer'
          },
           labelFormatter: function (): any {
              let point = this as any;
              let textcolor = chartproperties.darkTheme ? 'white' : 'black';
              let label = point.name;
              
              // Different handling for popup vs non-popup mode
                       if (!popUpState) {
  // Set legend item width
  const currentItemWidth =
    chartproperties.legendPosition === 'bottom'
      ? 200
      : getLegendItemWidth(chartproperties, popUpState);

  // Constants for spacing and font estimation
  const iconWidth = 10;
  const paddingLeft = 10;
  const availableWidth = currentItemWidth - iconWidth - paddingLeft;

  const fontSize = 0.8; // in em
  const avgCharWidth = fontSize * 8; // px per character (approx)
  const charsPerLine = Math.floor(availableWidth / avgCharWidth);

  // Split label into words
  const words = label.split(' ');
  let line1 = '';
  let line2 = '';
  let currentLine = '';

  for (let i = 0; i < words.length; i++) {
    const testLine = currentLine.length > 0 ? currentLine + ' ' + words[i] : words[i];

    if (testLine.length <= charsPerLine) {
      currentLine = testLine; // word fits, keep adding
    } else {
      if (line1 === '') {
        // Move currentLine to first line and start second line
        line1 = currentLine;
        currentLine = words[i]; // start second line
      } else {
        // Exceeded second line → truncate
        line2 = currentLine;
        currentLine = words[i];
        break;
      }
    }
  }

  // Assign remaining text
  if (!line1) {
    line1 = currentLine;
  } else if (!line2) {
    line2 = currentLine;
  }

  // If still words left beyond 2 lines → truncate second line
  const remainingWords = words.join(' ').length > (line1 + line2).length;
  if (remainingWords && line2.length > charsPerLine - 3) {
    line2 = line2.slice(0, charsPerLine - 3) + '...';
  }

  // Build final label
  if (line2) {
    label = `${line1}<br>${line2}`;
  } else {
    label = line1;
  }
}else {
                // For popup mode: original logic (single line break)
                const maxLen = 300;
                if (label.length > maxLen) {
                  const idx = label.lastIndexOf(' ', maxLen);
                  if (idx > 0) {
                    label = label.slice(0, idx) + '<br>' + label.slice(idx + 1);
                  }
                }
              }
              
              if (point.color != "#eeebed" && point.color != "#7f7f7f") {
                let legendMarginBottom = (chartproperties.legendPosition === 'left' || chartproperties.legendPosition === 'right') ? 'margin-bottom:4px;' : 'margin-bottom:2px;';
                
                // Apply position relative and left offset only for bottom legend position
                let positionStyle = chartproperties.legendPosition == 'bottom' ? '' : ''; // Remove left positioning to prevent overlap
                
                // Calculate legend width based on popup state and available space
                let legendWidth;
                if (popUpState) {
                  // Use fixed width for popup mode
                  if (chartproperties.legendPosition == 'bottom') {
                    legendWidth = '12rem'; // Smaller width for bottom legends to fit side by side
                  } else {
                    legendWidth = height != "100%" ? '30rem' : '29.5rem';
                  }
                } else {
                  if (chartproperties.legendPosition == 'bottom') {
                    // For bottom position, use smaller fixed width to allow side-by-side display
                    legendWidth = '25rem';
                  } else {
                    // Calculate available width for non-popup mode
                    const containerElement = document.getElementById('chart-container' + componentId);
                    if (containerElement) {
                      const containerWidth = containerElement.offsetWidth;
                      // Get chart size from responsive props (we'll use a fallback calculation)
                      const chartSizePercentage = chartproperties?.showLegend ? 0.65 : 0.75; // Based on our earlier size logic
                      const chartWidth = containerWidth * chartSizePercentage;
                      const availableWidth = containerWidth - chartWidth - 20; // 30px buffer
                      legendWidth = Math.max(150, availableWidth) + 'px'; // Minimum 150px width
                    } else {
                      legendWidth = '200px'; // Fallback width
                    }
                  }
                }
                
           let wrapStyle = '';
                  wrapStyle = `
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            white-space: normal;
            text-overflow: ellipsis;
            word-break: break-word;
        `;
  

    return '<div style="display:flex;align-items:center;font-size:0.8em;'  +legendMarginBottom + positionStyle + '" title="' + point.name + '">'
        + '<div style="display:flex;width:10px;height:10px;background-color:' + point.legendkeycolor + ';border-radius:50%"></div>'
        + '<div style="width:' + legendWidth + ';font-size:0.8em;margin-left:6px;color:' + textcolor + ';' +'padding-top:'+ (popUpState ? '1px' : '5px')+';'+ wrapStyle + 'flex:1;line-height:1.1;" title="' +  point.name + '">' + '   '+label + '</div>'
        + '</div>';
        }
              //   return '<div style="display:flex;align-items:center;font-size:0.8em;'  +positionStyle+ legendMarginBottom + '" title="' + point.name + '">' 
              //     + '<div style="display:flex;width:10px;height:10px;background-color:' + point.legendkeycolor + ';border-radius:50%"></div>'
              //     + '<div style="width:' + legendWidth + ';font-size:0.8em;padding-left:10px;padding-top:'+ (popUpState ? '1px' : '5px')+';color:' + textcolor + ';overflow:visible;white-space:normal;text-overflow:ellipsis;flex:1;line-height:1.2;" title="' +  point.name + '">' + '   ' + label + '   ' + '</div>'
              //     + '</div>';
              // }
            },
        },
             tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: chartproperties.toolTipStyle == "style1" ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',

          style: {
            fontSize: '0.8rem'
          },
          formatter: function (this: any): any {
            const pointWithMetric = this.point as {
              name?: any;
              parent?: any;
              color?: any;
              actualcolor?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              significance2?: string;
              samplesize?: number;
              tooltip?: any;
              Significance_Value?: any;
            };
            if (pointWithMetric.color === '#eeebed' || pointWithMetric.color === '#7f7f7f') { return false };
            const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
            if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

            let isDefaultTooltip = chartproperties.toolTipStyle;
            if (isDefaultTooltip == "style1") {
              const dotColor = pointWithMetric.actualcolor;
              const commonContent =
                `<div style="border: 1px solid ${dotColor}; font-size:0.8em; z-index: 100; padding: 10px; border-radius: 5px; margin: 0px; background-color: ${backgroundcolor2}; display: flex; align-items: center;">` +
                `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"></div>` +
                `<span style="margin-right: 5px;">${pointWithMetric.name} :</span>` +
                `<span>${pointWithMetric.tooltip}</span>`;
              return commonContent + '</div>';
            }
            else if (chartproperties.datalabelStyle === 'sigChange') {

            }
            else {
              const dotColor = pointWithMetric.actualcolor; // Get the series color

              const content =
                `<div style="background-color: ${backgroundcolor}; padding: 10px; align-items: center; border: 1px solid ${dotColor};font-size:0.8rem">` +
                `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0">${pointWithMetric.name}</div></div>` +
                `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;

              return content + '</div>';

            }



          },
        },
        plotOptions: {
          series: {
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                enabled: false
              },
              select: {
                enabled: false
              }
            }
          },
          pie: {
            // size: '95%',
            // innerSize: '40%',
              center: this.getResponsiveChartProps().center,
    size: this.getResponsiveChartProps().size,
    innerSize: this.getResponsiveChartProps().innerSize,
            showInLegend: chartproperties.showLegend,
            borderWidth:  1,
            borderColor: 'white',
            slicedOffset: 10,
            shadow: chartproperties.shadow ? {
              color: 'rgba(0, 0, 0, 0.5)',
              offsetX: 1,
              offsetY: 1,
              opacity: 0.5,
              width: 6,
            } : false,
            startAngle: -90,  // Set the start angle to 90
            endAngle: 90, 
            borderRadius: 0,
            pointPadding: 0.05,
            // center: ['50%', '60%'],
            dataLabels: {
              allowOverlap: true,
              // align: function (this: Highcharts.TooltipFormatterContextObject): string {
              //   // Align labels based on the position of the data point
              //   return (this.point.index % 2 === 0) ? 'left' : 'right';
              // },
              align: 'center',   // Align data label to the center of each slice
              verticalAlign: 'middle', 
              //alignTo: 'connectors',
              //y: 0,
              style: {
                textOutline: 'none',
                fontSize: chartproperties.dataLabelSize,
                fontWeight: "normal"
              },
              //padding:10,
              color:
                chartproperties.dataLabelColor == 'default'
                  ? chartproperties.darkTheme
                    ? 'white'
                    : 'black'
                  : chartproperties.dataLabelColor,
              crop: false,
              enabled: chartproperties.showDataLabel,
              // connectorWidth: chartproperties.connector ? 1 : -1,
              // connectorColor: null,
              // //color: chartproperties.dataLabelColor == "default" ? (chartproperties.darkTheme ? 'white' : 'black') : chartproperties.dataLabelColor,
              // connectorPadding: 0,
              // distance: chartproperties.connector ? 20 : 50,
              // connectorShape: 'crookedLine',
              // crookDistance: '70%',
              // softConnector: false,
              distance: 1,
              connectorWidth: -1,
              useHtml: true,
              formatter: function (this: Highcharts.TooltipFormatterContextObject): any {
                const pointWithMetric = this.point as {
                  name?: any;
                  parent?: any;
                  color?: any;
                  y?: number;
                  y1?: number;
                  cov?: string;
                  significance?: string;
                  samplesize?: number;
                  significance2?: any;
                  tooltip?: any;
                  isPercentage?: any;
                  Sig_LowerLimt?: any;
                  Sig_UpperLimt?: any;
                  Significance_Value?: any;
                  indexValue?: any;
                  actualIndexValue?: any;
                };
                if (this.point.color !== '#eeebed' && this.color != '#7f7f7f') {

                  chartproperties.dataLabelFormat = pointWithMetric.isPercentage;
                  ;
                  let textcolor = chartproperties.dataLabelColor;
                  if (chartproperties.datalabelStyle == 'datalabel') {
                    ;
                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                    text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style="color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                    );
                  }
                  //new
                  if (chartproperties.datalabelStyle === "index") {

                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                    text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));

                    // let text2 = pointWithMetric.y1 == 0 ? 'NA' :pointWithMetric.y1 == -1 ? -1 : pointWithMetric.y1 != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';
                    let text2 = pointWithMetric.actualIndexValue == null ? 'NA' : pointWithMetric.y1 == -1 ? -1 : pointWithMetric.y1 != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';

                    if (text2 == "-1" || text2 == -1) {
                      text2 = "NA";
                    }
                    text2 = configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize));

                    let color = configService.CheckIndexColoring(String(text2));
                    pointWithMetric.tooltip = text + "(" + text2 + ")";
                    return (
                      '<span style="font-size:0.5rem;color:' + textcolor + ';">' + text + " " + '<br>(' +
                      '<span style="color:' + color + ';font-size:0.45rem;">' + text2 + '</span>' + ')</span>'
                    );
                  }

                  if (chartproperties.datalabelStyle === 'sigChange') {
                    let textCheck = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesize));
                    let changeVal = pointWithMetric.isPercentage ? (Number(pointWithMetric.cov) * 100) : (Number(pointWithMetric.cov));
                    if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
                      let text = textCheck + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<br><span span style="font-size: 80%;color:black;">(${'NA'})</span>`;
                      pointWithMetric.tooltip = text;
                      return (
                        '<span style="color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                      );
                    }
                    else {
                      let sigClass = pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Value > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                      //let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + (textCheck !='I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) : 'NA'})</span>` : 'NA') : '');
                      let text = textCheck + ((chartproperties.dataLabelFormat && textCheck != 'I/S') ? '%' : '') + ' ' + (textCheck != 'I/S' ? (`<br><span style="font-size: 80%;  color: ${sigClass};">(` + `${(pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) + (chartproperties.dataLabelFormat ? '%' : '') : 'NA')})</span>`) : '');
                      pointWithMetric.tooltip = text;
                      return (
                        '<span style="color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                      );

                    }

                  }
                  if (chartproperties.datalabelStyle === 'change') {
                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<br><span span style="font-size: 80%;color:` + (chartproperties.darkTheme ? 'white' : 'black') + `">(` + `${pointWithMetric.cov} )</span>` : 'NA';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle === 'significance + changeVs') {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let sig = Number(pointWithMetric.significance);
                    let s =
                      sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                    let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<br><span span style="font-size: 80%;color:` + (chartproperties.darkTheme ? 'white' : 'black') + `">(` + `${pointWithMetric.cov} )</span>` + '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>' : 'NA';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' +
                      textcolor +
                      ';font-size:'+ chartproperties.dataLabelSize +'">' +
                      text +
                      '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle == 'significance') {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let sig = pointWithMetric.significance;
                    let s =
                      Number(sig) > 0 ? upwardTriangle : Number(sig) < 0 ? downwardTriangle : '';
                    let sigcolor = Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
                    let text = pointWithMetric.y1 != null ? (pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + '<span style="color:' + sigcolor + ';">' + s + '</span>') : 'NA';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' +
                      textcolor +
                      ';font-size:'+ chartproperties.dataLabelSize +'">' +
                      text +
                      '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle == 'ls') {
                    let text = Number(pointWithMetric.samplesize) > samplesizeconstant ? (pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '')) : 'LS';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle == "significance2") {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let text = pointWithMetric.y1 != null ? this.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                    let changeText = pointWithMetric.cov;
                    let sig = pointWithMetric.significance;
                    let sig1 = pointWithMetric.significance2;
                    let sColor = Number(sig) > 0 ? 'green' : (Number(sig) < 0 ? 'red' : '');
                    let s = Number(sig) > 0 ? upwardTriangle : (Number(sig) < 0 ? downwardTriangle : '');
                    let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : (chartproperties.darkTheme ? 'white' : 'black'));

                    if (Number(changeText) > 0) {
                      changeText = "+" + changeText;
                    }
                    pointWithMetric.tooltip = '<span>' + text +
                      (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
                        '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                        '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                      '</span>';
                    return (
                      '<span>' + text +
                      (pointWithMetric.y1 != null && changeText ? '&nbsp<br><span style="color:' + ';"> ' +
                        '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                        '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                      '</span>'
                    );
                  }
                } else {
                  return null;
                }
              },
            }

          }
        },
        series: this.seriesdata,
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        }
      } as any,
      );
    }
    else {
      localStorage.setItem("properties",JSON.stringify(this.chartproperties));
      HC_accessibility(Highcharts);
      let c=0;let chartimagepath=this.chartimagepath;
      let samplesizeconstant=this.samplesizeconstant;
      this.preparechartdata(jsondata,chartproperties.datalabelStyle=='ls',chartproperties.gradientBarColor);
      this.chart = Highcharts.chart(containerId, {
        accessibility: {
          point: {
            valueSuffix: '%',
          },
        },
        chart: {
          type: 'pie',
          marginTop:50,marginBottom:40,
          backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
          // events: {
          //   render: function () {
          //     const chart = this as any,
          //       centerX = chart.plotLeft + chart.plotWidth * 0.5,
          //       centerY = chart.plotTop + chart.plotHeight * 0.5,
          //       radius = Math.min(chart.plotWidth, chart.plotHeight) * 0.25; // Adjust the radius as needed
            
          //     // Check if the circle and image are already rendered
          //     if (!chart.baseCircle || !chart.groupImage) {
          //       // Render a circle
          //       if (!chart.baseCircle) {
          //         chart.baseCircle = chart.renderer
          //           .circle(centerX, centerY, 100) // Adjust the circle size as needed
          //           .attr({
          //             fill: '#f0eceb',
          //           })
          //           .add();
          //       }
            
          //       // Render an image
          //       if (!chart.groupImage) {
          //         let imageUrl = chartimagepath;
          //         chart.groupImage = chart.renderer
          //           .image(
          //             imageUrl,
          //             chart.plotLeft + chart.plotWidth / 2 - 50 / 2, // X position calculation
          //             chart.plotTop + chart.plotHeight / 2 - 50 / 2, // Y position calculation
          //             50,
          //             50
          //           )
          //           .attr({
          //             display: chartproperties.image ? 'block' : 'none',
          //           })
          //           .add();
          //       }
          //     }
            
          //     // Function to update the position of elements
          //     function updatePosition() {
          //       if (chart.baseCircle) {
          //         chart.baseCircle.attr({
          //           x: centerX,
          //           y: centerY,
          //         });
          //       }
            
          //       if (chart.groupImage) {
          //         chart.groupImage.attr({
          //           x: chart.plotLeft + chart.plotWidth / 2 - 50 / 2,
          //           y: chart.plotTop + chart.plotHeight / 2 - 50 / 2,
          //         });
          //       }
            
          //       // Call the function on the next animation frame
          //       requestAnimationFrame(updatePosition);
          //     }
            
          //     // Initial call to start the animation
          //     updatePosition();
          //   },
          // },
          style:{
            fontFamily: this.piechartservice.fontFamily,
            }
        },
        title: {
          text: "",
          align:chartproperties.chartTitlePosition,
          verticalAlign: 'top',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
            fontSize:"2rem"
          },
        },
       legend: {
          navigation: {
            itemMarginLeft: 10,
            activeColor: '#7f7f7f',
            animation: true,
            arrowSize: 10,
            inactiveColor: '#ccc',
           
            style: {
              fontSize: '0.7em',
              color: chartproperties.darkTheme ? 'white' : '#333',
            }
          },
          enabled:true,
          // y:chartproperties.legendPosition == 'bottom'?0:4,
          maxHeight: this.popUp?chartproperties.legendPosition == 'bottom' ? 45 : 300:0,
          layout:
            chartproperties.legendPosition != 'bottom'
              ? 'vertical'
              : 'horizontal',
          x: chartproperties.legendPosition=="right"?-30:chartproperties.legendPosition=="left"?-5:0,
          y:  -25,
          // width: height=='100%'?100:'100%',
            itemWidth: 100, // Set legend item width (adjust as needed)
          align: chartproperties.legendPosition,
          verticalAlign:
            chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
          symbolWidth: 0,  // Set to a valid non-negative value
          symbolHeight: 0, // Set to a valid non-negative value
          //symbolWidth: -1,
          //symbolHeight: -1,
          useHTML: true,
          itemMarginTop: 10,    // Adjust this value to reduce the top margin
           itemMarginLeft:chartproperties.legendPosition=="right"?-50:chartproperties.legendPosition=="left"?-30:0,
          itemMarginBottom: 10,
          itemStyle: {
            fontWeight: "normal",
            // fontSize: '0.8em',
            fontSize:(0.8 * ((this.popUp || this.height === '100%') ? 1.45 : 1)) + 'em',
            cursor: 'pointer'
          },
            labelFormatter: function (): any {
              let point = this as any;
              let textcolor = chartproperties.darkTheme ? 'white' : 'black';
              let label = point.name;
              
              // When popup is false, limit legend items to max 2 lines only
              if (!popUpState) {
                const maxCharsPerLine = chartproperties.legendPosition == 'bottom' ? 25 : 35;
                
                if (label.length > maxCharsPerLine) {
                  // Enforce 2 lines maximum when popup is false
                  const firstBreak = label.lastIndexOf(' ', maxCharsPerLine);
                  if (firstBreak > 0) {
                    const firstLine = label.slice(0, firstBreak);
                    const remaining = label.slice(firstBreak + 1);
                    
                    if (remaining.length > maxCharsPerLine - 3) {
                      // Second line needs truncation to fit in 2 lines only
                      const secondBreak = remaining.lastIndexOf(' ', maxCharsPerLine - 3);
                      const secondLine = secondBreak > 0 ?
                        remaining.slice(0, secondBreak) + '...' :
                        remaining.slice(0, maxCharsPerLine - 3) + '...';
                      label = firstLine + '<br>' + secondLine;
                    } else {
                      // Remaining text fits in second line
                      label = firstLine + '<br>' + remaining;
                    }
                  } else {
                    // Single line truncation if no space found
                    label = label.slice(0, maxCharsPerLine - 3) + '...';
                  }
                }
              }
              
              if (point.color != "#eeebed" && point.color != "#7f7f7f") {
                let legendMarginBottom = (chartproperties.legendPosition === 'left' || chartproperties.legendPosition === 'right') ? 'margin-bottom:4px;' : '';
                return '<div style="display:flex;align-items:center;font-size:0.8em;' + legendMarginBottom + '" title="' + point.name + '">' 
                  + '<div style="display:flex;width:10px;height:10px;background-color:' + point.color + ';border-radius:50%"></div>'
                  + '<div style="width:' + (height != "100%" ? '20rem' : '29.5rem') + ';font-size:0.8em;padding-left:10px;padding-top:'+ (popUpState ? '1px' : '5px')+';color:' + textcolor + ';overflow:visible;white-space:normal;text-overflow:ellipsis;flex:1;line-height:1.2;" title="' + point.name + '">' + '   ' + label + '   ' + '</div>'
                  + '</div>';
              }
            },
        },
         tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: chartproperties.toolTipStyle == "style1" ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',

          style: {
            fontSize: '0.8rem'
          },
          formatter: function (this: any): any {
            const pointWithMetric = this.point as {
              name?: any;
              parent?: any;
              color?: any;
              actualcolor?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              significance2?: string;
              samplesize?: number;
              tooltip?: any;
              Significance_Value?: any;
            };
            if (pointWithMetric.color === '#eeebed' || pointWithMetric.color === '#7f7f7f') { return false };
            const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
            if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

            let isDefaultTooltip = chartproperties.toolTipStyle;
            if (isDefaultTooltip == "style1") {
              const dotColor = pointWithMetric.color;
              const commonContent =
                `<div style="border: 2px solid ${dotColor}; font-size:0.8em; z-index: 100; padding: 15px; border-radius: 5px; margin: 0px; background-color: ${backgroundcolor2}; display: flex; align-items: center;">` +
                `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"></div>` +
                `<span style="margin-right: 5px;">${pointWithMetric.name} :</span>` +
                `<span>${pointWithMetric.tooltip}</span>`;
              return commonContent + '</div>';
            }
            else if (chartproperties.datalabelStyle === 'sigChange') {

            }
            else {
              const dotColor = pointWithMetric.color; // Get the series color

              const content =
                `<div style="background-color: ${backgroundcolor}; padding: 10px; align-items: center; border: 1px solid ${dotColor};font-size:0.8rem">` +
                `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0">${pointWithMetric.name}</div></div>` +
                `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;

              return content + '</div>';

            }



          },
        },
        plotOptions: {
          pie: {
            // borderWidth: chartproperties.border ? 2 : 0,
            // borderColor: chartproperties.border
            
            //   ? chartproperties.darkTheme
            //     ? 'white'
            //     : 'black'
            //   : 'null',
            borderWidth:  1,
            borderColor: 'white',
              shadow: chartproperties.shadow ? {
                color: 'rgba(0, 0, 0, 0.5)',
                offsetX: 1,
                offsetY: 1,
                opacity: 0.5,
                width: 6,
             } : false,
            startAngle: -90,
            endAngle:90,
             innerSize: '40%',
            borderRadius: 0,
            pointPadding: 0.05,
            center: this.getResponsiveChartProps().center, // Use responsive center positioning
            showInLegend: chartproperties.showLegend,
            
           // center: ['50%', '60%'],
    size: '90%',
   // innerSize: this.getResponsiveChartProps().innerSize,
            depth: 1,
            dataLabels: {
              style: {
                textOutline: 'none',
                fontSize: chartproperties.dataLabelSize,
                fontWeight:"normal"
              },
              enabled: chartproperties.showDataLabel,
              connectorWidth: chartproperties.connector?1:-1,
              connectorColor: null,
              connectorPadding: 0,
               color:chartproperties.dataLabelColor=="default"?(chartproperties.darkTheme?'white':'black'):chartproperties.dataLabelColor,
              distance: chartproperties.connector?10:0,
              useHtml: true,
              allowOverlap:true,
              formatter: function (this: Highcharts.TooltipFormatterContextObject): any {
                const pointWithMetric = this.point as {
                  name?:any;
                  parent?:any;
                  color?:any;
                  y?: number;
                  y1?: number;
                  cov?: string;
                  significance?: string;
                  samplesize?: number;
                  significance2?:any;
                  tooltip?:any
                };
                let textcolor = chartproperties.darkTheme ? 'white' : 'black';
                if (chartproperties.datalabelStyle == 'datalabel') {
                  let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat?'%':'') : 'NA';
                  pointWithMetric.tooltip=text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                }
                if (chartproperties.datalabelStyle === 'change') {
                  let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat?'%':'')+' ' + `<br><span span style="font-size: 80%;color:`+(chartproperties.darkTheme?'white':'black')+`">(`+(Number(pointWithMetric.cov)>0?'+':'')+`${pointWithMetric.cov} )</span>` : 'NA';
                  pointWithMetric.tooltip=text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                }
                 if (chartproperties.datalabelStyle === 'significance + changeVs') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = Number(pointWithMetric.significance);
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat?'%':'')+' ' +  `<span span style="font-size: 80%;color:`+(chartproperties.darkTheme?'white':'black')+`">(`+(Number(pointWithMetric.cov)>0?'+':'')+`${pointWithMetric.cov} )</span>` +  '<span style="color:' +
                  sigcolor +
                  ';">' +
                  s +
                  '</span>' : 'NA';
                  pointWithMetric.tooltip=text;
                  return (
                    '<span style:"color:' +
                    textcolor +
                    ';">' +
                    text +
                   '</span>'
                  );
                }
                if (chartproperties.datalabelStyle == 'significance') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = Number(pointWithMetric.significance);
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  let text =
                  pointWithMetric.y1 != null
                      ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '')+'<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                      : 'NA';
                  pointWithMetric.tooltip=text;
                  return (
                    '<span style:"color:' +
                    textcolor +
                    ';">' +
                    text +
                    '</span>'
                  );
                }
                if (chartproperties.datalabelStyle == 'ls') {
                  let text = Number(pointWithMetric.samplesize)>samplesizeconstant?(pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y + (chartproperties.dataLabelFormat?'%':'')):'LS';
                  pointWithMetric.tooltip=text;
                  return (
                    '<span style:"color:' + textcolor + ';">' + text + '</span>'
                  );
                }
                if (chartproperties.datalabelStyle == "significance2") {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let text = pointWithMetric.y1 != null ? this.y + (chartproperties.dataLabelFormat?'%':'') : 'NA';
                  let changeText = pointWithMetric.cov;
                  let sig = pointWithMetric.significance;
                  let sig1 = pointWithMetric.significance2;
                  let sColor = Number(sig) > 0 ? 'green' : (Number(sig) < 0 ? 'red' : '');
                  let s = Number(sig) > 0 ? upwardTriangle : (Number(sig) < 0 ? downwardTriangle : '');
                  let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : (chartproperties.darkTheme?'white':'black'));
                  c++;
  
                  if (Number(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  pointWithMetric.tooltip='<span>' + text +
                  (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
                    '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                    '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                  '</span>';
                  return (
                    '<span>' + text +
                    (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
                      '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>'
                  );
                }
              },
            },
          },
        },
        series: this.seriesdata,
        credits: {
          enabled: false,
        },
        exporting:{
          enabled:false
        }
      } as any);
    }
    
  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.piechartservice.applycustomization(event,item, this.chartproperties)
    this.plotChart('chart-container'+this.id,this.jsondata['data'],this.chartproperties);
    }

  userselectedproperties(){
    // this.jsondata['data']=this.jsondata['data'].slice(0,10);
    this.jsondata['properties'][0]=this.chartproperties;
    return JSON.stringify(this.jsondata).toString();
  }

}
